import axios from 'axios'
import * as CookieService from './CookieService'

const SESSION_COOKIES = ['bearer_token', 'company_name', 'company_id', 'company_start_date', 'user_id', 'user_fullname']

export const clearSession = () => {
  SESSION_COOKIES.forEach(CookieService.remove)
  localStorage.removeItem('userData')
}

const apiClient = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_PREFIX_URL}`,
  headers: { Accept: 'application/json' }
})

// Attach the bearer token at request time so a fresh login is picked up immediately
apiClient.interceptors.request.use(config => {
  const token = CookieService.get('bearer_token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

// Central 401/403 handling: log out and return to login (except while on the login page itself)
apiClient.interceptors.response.use(
  response => response,
  error => {
    const status = error.response && error.response.status
    const onLoginPage = window.location.pathname.endsWith('/login')
    if ((status === 401 || status === 403) && !onLoginPage) {
      clearSession()
      window.location.href = '/login'
    }
    return Promise.reject(error)
  }
)

export default apiClient
